import React, { useRef, useState } from 'react';
import classnames from 'classnames';
import ChevronSVG from '../../../../../../images/svg/icons8-expand-arrow';
import { Popover } from '../../../../../global/popover/popover';
import './operator-role-dropdown.scss';
import Text from '../../../../../global/text/text';
import { OperatorRole } from '../../../../../../api/operators.dao';
import { FormattedMessage, useIntl } from 'react-intl';

interface IProps {
    onChange?: (option: OperatorRole | null ) => void;
    selectedRole?: OperatorRole;
    shouldDisabledItems?: boolean;
}

const ROLE_OPTIONS = Object.values(OperatorRole);

const OperatorsRoleDropdownPresentation = (props: IProps ) => {
    const statusButtonRef = useRef(null);
    const [isStatusModalOpen, setStatusModalOpen] = useState(false);
    const { onChange, selectedRole, shouldDisabledItems } = props;

    const { formatMessage } = useIntl();

    const handleOnOptionSelect = (newOption: OperatorRole) => {
        onChange(newOption === selectedRole ? null : newOption);
        setStatusModalOpen(false);
    };

    return (
        <div className={classnames('operator-roles-dropdown connection-dropdown', {
            'connection-dropdown--selected': !!selectedRole,
            'connection-dropdown--active': isStatusModalOpen,
            'operator-roles-dropdown__disabled': shouldDisabledItems
        })} ref={statusButtonRef}>
            <div className='connection-dropdown__wrapper'
                onClick={shouldDisabledItems ? undefined : () => setStatusModalOpen(prevState => !prevState)}>
                <div className='connection-dropdown__team'>
                    <Text
                        className={classnames('connection-dropdown__label', {
                            'connection-dropdown__label--visible': true
                        })}
                        message={
                            selectedRole ? formatMessage(
                                {
                                id: `oe.operators.roleOptions.${selectedRole}`,
                                description: 'Operator role option',
                            }) :
                                formatMessage(
                                    {
                                        id: 'oe.operators.roleOptions.placeholder',
                                        description: 'Operator role option',
                                        defaultMessage: 'Assign role...',
                                    })
                        }
                        withEllipsis
                    />
                    <ChevronSVG />
                </div>
            </div>
            <Popover
                padding={0}
                isOpen={isStatusModalOpen}
                buttonRef={statusButtonRef}
                onClickOutside={() => setStatusModalOpen(false)}
                customWidth={statusButtonRef.current?.getBoundingClientRect().width}
            >
                <div className='connection-dropdown__options'>
                    {ROLE_OPTIONS.map(role =>
                        <div
                            className={classnames('connection-dropdown__option', {
                                'connection-dropdown__option--selected': selectedRole === role
                            })}
                            key={role}
                            onClick={() => handleOnOptionSelect(role)}
                        >
                            <FormattedMessage
                                id={`oe.operators.roleOptions.${role}`}
                                description='Operator role option'
                            />
                        </div>
                    )}
                </div>
            </Popover>
        </div>
    );
};

export { OperatorsRoleDropdownPresentation };
